









































import { Component, Vue, Watch } from 'vue-property-decorator';
import { routes } from '@/router/router';
import { eventBus } from '@/main';
import { RouteConfig } from 'vue-router';
import { Menu } from 'ant-design-vue';

const SubMenu = {
    template: `
      <a-sub-menu :key="menuInfo.key" v-bind="$props" v-on="$listeners" v-if="menuInfo.meta.visible">
        <span slot="title">
          <a-icon type="caret-right" style="transition: 0.3s ease-in-out;font-size: 12px" :style="{transform:isExpanded? 'rotate(90deg)':''}" /><span>{{ menuInfo.meta.title}}</span>
        </span>
        <template v-for="item in menuInfo.children">
         <a-menu-item v-if="!item.children && item.meta.visible" :id="item.path" :key="item.name">
                        <span>{{ item.meta.title }}</span>
                    </a-menu-item>
                    <sub-menu v-else-if="item.children" :is-expanded="openNames.includes(item.name)" :key="item.name" :menu-info="item" :open-names="openNames" > </sub-menu>
        </template>
      </a-sub-menu>
    `,
    name: 'SubMenu',
    // must add isSubMenu: true
    isSubMenu: true,
    props: {
        ...(Menu.SubMenu as unknown as { props: object }).props,
        // Cannot overlap with properties within Menu.SubMenu.props
        menuInfo: {
            type: Object,
            default: () => ({}),
        },
        openNames: {
            type: Array,
            default: () => [],
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
    },
};

/**
 * @author guan
 * @description 数据管理界面
 */
@Component({
    components: { 'sub-menu': SubMenu },
})
export default class DataManage extends Vue {
    /** */
    private routes = routes;
    /** 当前选中的key */
    selectKeys: string[] = [];
    /** 当前展开的key数组 */
    openKeys: string[] = [];

    /**
     *
     */
    get isTypicalLibraryEditMode(): boolean {
        return this.$store.state.isTypicalLibraryEditMode;
    }

    /**
     * 检查这个菜单项目是否该显示
     */
    getMenuItemIsShow(item: RouteConfig): boolean {
        return !(this.isTypicalLibraryEditMode && item.meta?.disableInTypicalLib);
    }

    /**
     *搜寻选择key的父key
     */
    searchOpenKeys(childKey: string): string[] {
        const openKeys = new Array<string>();
        const searchNode = (node: RouteConfig): boolean => {
            if (node.name === childKey) {
                return true;
            } else if (node.children != null && node.children.length > 0) {
                if (node.children.map((item) => searchNode(item)).reduce((previousValue, currentValue) => previousValue || currentValue)) {
                    openKeys.push(node.name as string);
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        };
        this.routes.forEach((item) => searchNode(item));
        return openKeys;
    }
    /**
     * @author guan
     * @description 将路径转换为数组对象
     * @return void
     * @param route 路径
     */
    routeToArray(route: string): { routeArr: string[]; params: string } {
        if (!route) {
            return {
                routeArr: [],
                params: '',
            };
        }
        const arr: string[] = route.split('/');
        const ret: string[] = [];
        let params = '';
        arr.shift();
        arr.forEach((item, index) => {
            if (parseInt(item, 10)) {
                params = item;
                return;
            }
            ret.push(index ? item : `/${item}`);
        });
        return {
            routeArr: ret,
            params,
        };
    }
    /**
     * @author guan
     * @description
     * @return void
     */
    mounted(): void {
        this.selectKeys = [this.$route.name as string];
        this.openKeys = this.searchOpenKeys(this.$route.name as string);
        eventBus.$on('upMenuStates', () => {
            this.selectKeys = ['weather_data'];
        });
    }
    /**
     *
     */
    get routeName(): string | null | undefined {
        return this.$route.name;
    }
    /**
     *
     */
    @Watch('routeName')
    routeNameChange(): void {
        this.selectKeys = [this.$route.name as string];
        this.openKeys = this.searchOpenKeys(this.$route.name as string);
    }

    /**
     * @author guan
     * @description  跳转路径
     * @return void
     * @param item 操作的key
     */
    openPage(item: { key: string }): void {
        const query = this.$route.query;
        let route = {
            name: item.key,
            query: query,
        };
        this.$router
            .push(route)
            .then(() => {
                const currentNavigation = String(this.$router.currentRoute.matched[1].name);
                this.$store.commit('setNavigationRecord', { key: currentNavigation, value: item.key });
                eventBus.$emit('reload');
            })
            .catch((e: Error) => {
                console.log(e.message);
            });
    }
    /**
     * @author guan
     * @description 获取当前路径下的数据
     * @return number 返回index
     */
    get Group(): unknown {
        let parentPath: string = this.routeToArray(this.$route.path).routeArr[0];
        let childrenPath: string = this.routeToArray(this.$route.path).routeArr[1];
        if (this.$route.path.includes('/ies')) {
            if (this.$route.path === '/ies/simu/open') {
                parentPath = '/ies';
                childrenPath = this.routeToArray(this.$route.path).routeArr[1] + '/' + this.routeToArray(this.$route.path).routeArr[2];
            } else {
                parentPath = this.routeToArray(this.$route.path).routeArr[0] + '/' + this.routeToArray(this.$route.path).routeArr[1];
                childrenPath = this.routeToArray(this.$route.path).routeArr[2];
            }
        }
        const parentIndex = this.routes.findIndex((x) => x.name === parentPath);
        let childIndex = 0;
        if (parentIndex === -1) {
            throw new Error('未知错误');
        } else {
            childIndex = (this.routes[parentIndex].children as unknown[]).findIndex((x) => (x as { path: string }).path === childrenPath);
        }
        return { PIndex: parentIndex, CIndex: childIndex };
    }
}
